/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-pages-select.vue?vue&type=template&id=9a5838b8&scoped=true"
import script from "./j-pages-select.vue?vue&type=script&lang=js"
export * from "./j-pages-select.vue?vue&type=script&lang=js"
import style0 from "./j-pages-select.vue?vue&type=style&index=0&id=9a5838b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5838b8",
  null
  
)

export default component.exports